// Repositories built on `defaultRepositoryError` reject with an already
// composed message string instead of resolving to `{ isError: true }`, so a
// caller awaiting one directly has to catch it. Turns whatever was thrown into
// something safe to show.
const rejectionMessage = (failure: unknown, fallback: string): string => {
  if (typeof failure === 'string' && failure.trim()) return failure.trim();
  if (failure instanceof Error && failure.message) return failure.message;
  return fallback;
};

export default rejectionMessage;
